<template>
  <div :class="{ active: show }" class="cx-bfet">
    <div>
      <div class="pp-box">
        <div class="pp-bt-box">
          <div class="cx-box">
            <div class="pp-bt-x" @click="close()">
              <!-- <uni-icons type="closeempty" size="16" color="#3F51B5"></uni-icons> -->
              <close-circle-outlined style="font-size: 24px; cursor: pointer; color: #555" />
            </div>
          </div>
        </div>
        <!-- <div class="cx-gou" v-if="icon">
          <uni-icons custom-prefix="encrypt" type="icon-gou" size="60" color="#52c41a"></uni-icons>
        </div> -->
        <div class="cx-title" style="font-size: 18px; font-weight: bold">
          {{ title }}
        </div>
        <div class="cx-title" style="font-size: 15px; color: #666" v-if="desc.length > 0">
          {{ desc }}
        </div>
        <div class="cx-btn-box">
          <div class="cx-btn" @click.stop="cancel" v-if="cancelShow">
            {{ cancelText || 'cancel' }}
          </div>
          <div class="cx-btn d2" @click.stop="ok">
            {{ okText || 'ok' }}
          </div>
        </div>

        <!-- <div class="pp-zrf-desc">
				<div style="display: flex;align-items: flex-start;">
					<uni-icons type="info-filled" size="22" color="#ccc" style="transform: rotate(180deg);"></uni-icons>
				</div>
				<div class="pp-zrf-text">
					转账费——以 ETH、USDT、USDC、TUSD 支付账单时征收的费用，以确保交易在区块链网络上进行。
				</div>
			</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
export default {
  name: 'toastVue',
  components: {
    CloseCircleOutlined
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: ''
    },
    ok: {
      type: Function,
      default: () => {}
    },
    cancelText: {
      type: String,
      default: ''
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    cancelShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style scoped>
.cx-bfet {
  position: fixed;
  top: 0;
  background: #000000b5;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  transition: all 0.15s;
}

.cx-bfet.active {
  visibility: visible;
  opacity: 1;
}

.pp-box {
  width: 420px;
  padding: 20px;
  background: #141a20;
  border-radius: 10px;
  margin-top: 50%;
  position: relative;
}

.pp-bt-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pp-bt-x {
  width: 25px;
  height: 25px;
  /* background-color: #e7e7e7; */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pp-wl-list {
  display: flex;
  margin-top: 20px;
}

.pp-wll-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.pp-wll-title {
  font-size: 16px;
  color: #656565;
}

.pp-wll-left {
}

.pp-wl-desc {
  display: flex;
  align-items: center;
  gap: 5px;
}

.pp-zrf-desc {
  margin-top: 20px;
  padding: 10px;
  border-radius: 10px;
  background-color: #f5f5f5;
  display: flex;
  gap: 2px;
}

.pp-zrf-text {
  font-size: 13px;
  color: #888;
}

.pp-i-title {
  color: #444;
}

.cx-box {
  position: absolute;
  top: 15px;
  right: 15px;
}

.cx-gou {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.cx-title {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #fff;
}

.cx-btn {
  flex: 1;
  padding: 15px;

  color: #8a949f;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
}

.cx-btn:nth-child(1) {
  background: hsla(0, 0%, 100%, 0.06);
  color: #fff;
}

.cx-btn:nth-child(2) {
  background-color: var(--pay-color);
  color: #fff;
}

.cx-btn.d2 {
  background-color: var(--pay-color);
  color: #fff;
}

.cx-btn-box {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}
</style>
